import * as types from './mutation-types'
import { getScheduleTasksQuery } from './queries.graphql'
import api from "@/modules/api";
import gqlClient from '@/modules/graphql'

const actions = {
  async getScheduledTasks({
    commit
  }, variables = {}) {
    if(!variables.storeId){
      return []
    }

    try {
      commit(types.GET_SCHEDULED_TASK_DATA_BEGIN)
      const {
        data: {
          data:{
            store:{
              tasks
            }
          }
        }
      } = await gqlClient.query({
        query     : getScheduleTasksQuery,
        variables : variables
      })

      commit(types.GET_SCHEDULED_TASK_DATA_SUCCESS, tasks)
    } catch (e) {
      commit(types.GET_SCHEDULED_TASK_DATA_ERROR, e)
    }
  },

  async updateTaskAssignment({ commit }, { id, data ,rowNumber }) {
    commit(types.TASK_ASSIGNMENT_BEGIN, rowNumber);

    try {
      const { data : updatedData } = await api.taskAssignment.updateTaskAssignment(id, data)
      commit(types.TASK_ASSIGNMENT_SUCCESS, { updatedData, index : rowNumber });
    } catch (e) {
      commit(types.TASK_ASSIGNMENT_ERROR, { e, id : rowNumber });
    }
  }
}

export default actions